class conceptos {
  constructor(id, name, fixed) {
    this.id = id;
    this.name = name;
    this.fixed = fixed;
    this.autoriza = fixed !== 0 ? true : false;
    this.fixedTable =
      fixed === 1
        ? "Autoriza"
        : fixed === 2
        ? "Autorización previa"
        : "No autoriza";
  }
  static fromJson({ conceptoId, nombre, autoriza }) {
    return new conceptos(conceptoId, nombre, autoriza);
  }
}
export default conceptos;
